import * as Immutable from "immutable";
import FindWidgetAndQueryIdInView from "views/logic/views/FindWidgetAndQueryIdInView";
import ViewState from "views/logic/views/ViewState";
import View from "views/logic/views/View";
const ExtractViewStateDataForWidget = ({ widgetId, view, queryId }) => {
  const currentViewState = view.state.get(queryId);
  const widgetMapping = Immutable.Map({ [widgetId]: currentViewState.widgetMapping.get(widgetId) });
  const titles = Immutable.Map({
    widget: Immutable.Map({ [widgetId]: currentViewState.titles.get("widget").get(widgetId) })
  });
  const widgetPosition = currentViewState.widgetPositions[widgetId].toBuilder().col(0).row(0).build();
  return { titles, widgetPosition, widgetMapping };
};
const GetViewState = ({ widget, titles, widgetPosition, widgetMapping }) => ViewState.create().toBuilder().widgets([widget]).titles(titles).widgetPositions({ [widget.id]: widgetPosition }).widgetMapping(widgetMapping).build();
const CreateViewWithOneWidget = ({
  titles,
  search,
  widget,
  widgetPosition,
  widgetMapping,
  queryId,
  viewType = View.Type.Search
}) => {
  const viewState = GetViewState({ widget, widgetPosition, widgetMapping, titles });
  return View.create().toBuilder().newId().type(viewType).search(search).state({ [queryId]: viewState }).build();
};
const ExtractWidgetIntoNewView = (view, widgetId, viewType = View.Type.Search) => {
  const [widget, queryId] = FindWidgetAndQueryIdInView(widgetId, view);
  const { widgetPosition, widgetMapping, titles } = ExtractViewStateDataForWidget({ widgetId, view, queryId });
  const { search } = view;
  return CreateViewWithOneWidget({ titles, widgetPosition, widget, queryId, widgetMapping, search, viewType });
};
export default ExtractWidgetIntoNewView;
